/**
 * Constantes canónicas partilhadas (estados, tipos, enumerações).
 *
 * Centraliza os literais de string usados em comparações `===` espalhadas pela
 * app, para que um rename não exija encontrar todas as ocorrências. Os valores
 * continuam idênticos aos do backend (snake_case) — só a referência muda.
 *
 * Nota: `PAYMENT_RECURRENCES` (array) e o runtime map
 * `PAYMENT_RECURRENCE_MONTHS` já vivem canonicamente em
 * `components/liabilities/debtTypes.js` — não duplicar aqui.
 */

/** Estados de um SmartGoal (backend `GoalStatus`). */
export const GOAL_STATUSES = Object.freeze({
  ACTIVE: 'active',
  COMPLETED: 'completed',
  PAUSED: 'paused',
  ON_TRACK: 'on_track',
  OFF_TRACK: 'off_track',
});

/** Tipos de alocação orçamental (backend `AnnualBudgetAllocation`). */
export const ALLOCATION_TYPES = Object.freeze({
  ESSENTIAL: 'essential',
  LIFESTYLE: 'lifestyle',
  PERSONAL_INVESTMENT: 'personal_investment',
});

/** Base de rendimento / recorrência da fonte (backend `IncomeSource.recurrence`). */
export const INCOME_RECURRENCES = Object.freeze({
  MONTHLY_FIXED: 'monthly_fixed',
  MONTHLY_VARIABLE: 'monthly_variable',
  OCCASIONAL: 'occasional',
});

/** Alias histórico — alguns fluxos referem-se a isto como "basis". */
export const INCOME_BASIS = INCOME_RECURRENCES;

/** Passos do wizard de fundo de emergência (backend `wizard_step`). */
export const WIZARD_STEPS = Object.freeze({
  COMPLETED: 'completed',
});
